import { FmsApi } from "../fmsapi"

export default class BaseController {
  constructor(protected api: FmsApi, protected name: string) {}

  protected async callApi<T>(path: string, data?: any): Promise<T> {
    try {
      const response = await this.api.callApi(`/${this.name}/${path}`, data)
      return response.json() as T
    } catch (error) {
      console.error("Error calling API:", error)
      throw error
    }
  }

  protected async getCallApi<T>(path: string, data?: any): Promise<T> {
    try {
      const response = await this.api.callApiWithGet(`/${this.name}/${path}`, data)
      return response.json() as T
    } catch (error) {
      console.error("Error calling API:", error)
      throw error
    }
  }

  /**
   * !DNS 문제로 https://api.ipify.org IP가 127.0.0.1로 Request를 보냄
   * !다른 API 찾아야 할것 같습니다.
   * @returns
   */
  protected async getIP(): Promise<string> {
    try {
      const response = await fetch("https://api.ipify.org?format=json")
      const data = await response.json()
      return data.ip
    } catch (error) {
      console.error("Error getting IP:", error)
      return "error"
    }
  }
}
